import get from 'lodash.get';
import reloadRequiredActionsTypes from '../constants/reload-required-action-types';
import { UPDATE_STATIC_ONLY } from '../../hdrm/constants/update-strategies';

const isReloadRequired = (action) => {
  const strategy = get(action, 'payload.options.strategy');

  return strategy === UPDATE_STATIC_ONLY || reloadRequiredActionsTypes.includes(action.type);
};

export default isReloadRequired;
